const actions = {
  LISTING_ADD_BEGIN: 'LISTING_ADD_BEGIN',
  LISTING_ADD_SUCCESS: 'LISTING_ADD_SUCCESS',
  LISTING_ADD_ERR: 'LISTING_ADD_ERR',
  
  LISTINGS_READ_BEGIN: 'LISTINGS_READ_BEGIN',
  LISTINGS_READ_SUCCESS: 'LISTINGS_READ_SUCCESS',
  LISTINGS_READ_ERR: 'LISTINGS_READ_ERR',

  LISTING_UPDATE_BEGIN: 'LISTING_UPDATE_BEGIN',
  LISTING_UPDATE_SUCCESS: 'LISTING_UPDATE_SUCCESS',
  LISTING_UPDATE_ERR: 'LISTING_UPDATE_ERR',

  LISTING_DELETE_BEGIN: 'LISTING_DELETE_BEGIN',
  LISTING_DELETE_SUCCESS: 'LISTING_DELETE_SUCCESS',
  LISTING_DELETE_ERR: 'LISTING_DELETE_ERR',

  LISTING_READ_BEGIN: 'LISTING_READ_BEGIN',
  LISTING_READ_SUCCESS: 'LISTING_READ_SUCCESS',
  LISTING_READ_ERR: 'LISTING_READ_ERR',
  CLEAR_LISTING: 'CLEAR_LISTING',

  LISTING_UPDATE_MEDIA_BEGIN: 'LISTING_UPDATE_MEDIA_BEGIN',
  LISTING_UPDATE_MEDIA_SUCCESS: 'LISTING_UPDATE_MEDIA_SUCCESS',
  LISTING_UPDATE_MEDIA_ERR: 'LISTING_UPDATE_MEDIA_ERR',
  

  axiosReadBegin: () => {
    return {
      type: actions.LISTINGS_READ_BEGIN,
    };
  },

  axiosReadSuccess: data => {
    return {
      type: actions.LISTINGS_READ_SUCCESS,
      data,
    };
  },

  axiosReadErr: err => {
    return {
      type: actions.LISTINGS_READ_ERR,
      err,
    };
  },

  axiosAddBegin: () => {
    return {
      type: actions.LISTING_ADD_BEGIN,
    };
  },

  axiosAddSuccess: data => {
    return {
      type: actions.LISTING_ADD_SUCCESS,
      data,
    };
  },

  axiosAddErr: err => {
    return {
      type: actions.LISTING_ADD_ERR,
      err,
    };
  },

  // Update

  axiosUpdateBegin: () => {
    return {
      type: actions.LISTING_UPDATE_BEGIN,
    };
  },

  axiosUpdateSuccess: data => {
    return {
      type: actions.LISTING_UPDATE_SUCCESS,
      data,
    };
  },

  axiosUpdateErr: err => {
    return {
      type: actions.LISTING_UPDATE_ERR,
      err,
    };
  },

  axiosDeleteBegin: () => {
    return {
      type: actions.LISTING_DELETE_BEGIN,
    };
  },

  axiosDeleteSuccess: data => {
    return {
      type: actions.LISTING_DELETE_SUCCESS,
      data,
    };
  },

  axiosDeleteErr: err => {
    return {
      type: actions.LISTING_DELETE_ERR,
      err,
    };
  },

  axiosSingleDataBegin: () => {
    return {
      type: actions.LISTING_READ_BEGIN,
    };
  },

  axiosSingleDataSuccess: data => {
    return {
      type: actions.LISTING_READ_SUCCESS,
      data,
    };
  },

  axiosSingleDataErr: err => {
    return {
      type: actions.LISTING_READ_ERR,
      err,
    };
  },

  axiosClearListing: () => {
    return {
      type: actions.CLEAR_LISTING,
    };
  },

  axiosUpdateMediaBegin: () => {
    return {
      type: actions.LISTING_UPDATE_MEDIA_BEGIN,
    };
  },

  axiosUpdateMediaSuccess: data => {
    return {
      type: actions.LISTING_UPDATE_MEDIA_SUCCESS,
      data,
    };
  },

  axiosUpdateMediaErr: err => {
    return {
      type: actions.LISTING_UPDATE_MEDIA_ERR,
      err,
    };
  },

};

export default actions;
